import { filter_enforceOnlyAllowedFieldTypes, INCOMPATIBLE_FIELD_TYPE_SHORT } from '..';
import { DTOCustomField, } from './model';
export const transformRestMyselfToDTO = (myself) => {
    return {
        name: myself.name,
        displayName: myself.displayName,
        accountId: myself.accountId,
        groups: {
            size: myself.groups ? myself.groups.size : 0,
            items: myself.groups && myself.groups.items ? myself.groups.items.map((g) => ({ groupName: g.name, groupId: g.groupId })) : [],
        },
        emailAddress: myself.emailAddress,
        locale: myself.locale,
        timeZone: myself.timeZone,
        avatarUrls: {
            '48x48': myself.avatarUrls ? myself.avatarUrls['48x48'] : null,
            '24x24': myself.avatarUrls ? myself.avatarUrls['24x24'] : null,
            '16x16': myself.avatarUrls ? myself.avatarUrls['16x16'] : null,
            '32x32': myself.avatarUrls ? myself.avatarUrls['32x32'] : null,
        },
    };
};
export const transformStorageV1PermissionToDTO = (fieldId, contextId, users, groups) => {
    // Note: permissions.users = List of accountIds!
    // Note: users = List of users with names!
    return {
        fieldId: fieldId,
        contextId: contextId,
        users: users,
        groups: groups,
    };
};
export const transformContextToDTO = (context) => {
    return {
        contextId: context.id,
        contextName: context.name,
        contextDescription: context.description,
        issueTypes: [],
        projects: [],
        isGlobalContext: context.isGlobalContext,
        isAnyIssueType: context.isAnyIssueType,
    };
};
export const transformCustomFieldTypeForFrontend = (fieldType) => {
    const replaced = `${fieldType}`.replace('com.atlassian.jira.plugin.system.customfieldtypes:', '');
    // console.log('transformCustomFieldTypeForFrontend', replaced);
    return replaced;
};
export const transformFieldDetailsToDTO = (field) => {
    return new DTOCustomField(field.id, field.name, field.schema ? transformCustomFieldTypeForFrontend(field.schema.custom) : INCOMPATIBLE_FIELD_TYPE_SHORT, field.description, false, field.isLocked === true, filter_enforceOnlyAllowedFieldTypes(field));
};
export const transformRestOptionsToDTO = (options) => {
    let optionsDTO = [];
    if (options.values) {
        optionsDTO = options.values.map((o) => ({
            id: o.id,
            value: o.value,
            disabled: o.disabled,
            optionId: o.optionId,
        }));
    }
    return {
        maxResults: options.maxResults,
        startAt: options.startAt,
        total: options.total,
        isLast: options.isLast,
        values: optionsDTO,
    };
};
